$(document).ready(function() {
  $('#clinic').select2({
    placeholder: 'Search or enter your clinic',
    allowClear: true,
    tags: true,  // Allows adding custom values
    createTag: function (params) {
      return {
        id: params.term,
        text: params.term,
        newOption: true  // Flags custom inputs
      };
    },
    templateResult: function (data) {
      var $result = $('<span></span>');
      $result.text(data.text);
      if (data.newOption) {
        $result.append(' <em>(new)</em>');  // Adds a marker for new custom entries
      }
      return $result;
    },
    minimumInputLength: 0  // Show options immediately on click
  }).on('select2:open', function () {
    $('.select2-search__field').focus();  // Automatically focus on search field when opened
  });
});
